<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-toolbar(flat dense).secondary
          v-icon.white--text fa-search
          v-toolbar-title.white--text Fabric売上明細

    v-layout(row wrap)
      v-flex(xs12 sm6 offset-sm3 md4 offset-md-4)
        v-card
          v-card-text.pa-2
            v-menu(
              lazy
              :close-on-content-click="false"
              v-model="periodFromPicker"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
              )
              v-text-field(
                label="開始日"
                slot="activator"
                :value="periodFrom|date"
                prepend-icon="schedule"
                outline
                readonly
              )
              v-date-picker(
                v-model="periodFrom"
              )
            v-menu(
              lazy
              :close-on-content-click="false"
              v-model="periodToPicker"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
              )
              v-text-field(
                label="終了日"
                slot="activator"
                :value="periodTo|date"
                prepend-icon="schedule"
                outline
                readonly
              )
              v-date-picker(
                v-model="periodTo"
              )
          v-card-text.pa-2
            p.text-xs-center
              span {{periodFrom}} - {{periodTo}}
          v-card-actions.pa-2
            v-btn(
              color="primary"
              block
              large
              @click="download"
              :disabled="exclusiveLock"
            )
              v-icon(left) fa-search
              span この条件でExcel出力

    div#download-excel-frame(style="display: none;")

</template>

<script>
import rules from '@/common/mixins/rules'

export default {
  data () {
    return {
      periodFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
      periodTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
      periodFromPicker: false,
      periodToPicker: false,
      exclusiveLock: false
    }
  },
  mixins: [rules],
  methods: {
    download () {
      let main = document.getElementById('download-excel-frame')
      while (main.firstChild) {
        main.removeChild(main.firstChild)
      }
      const url = `/order/download_sales_report_for_fabric`
      const params = {
        date_from: this.periodFrom,
        date_to: this.periodTo
      }
      this.$ajax.post(url, params)
        .then(response => {
          if (response.data.count === 0) {
            this.$toastr.info('該当するデータはありません。')
            return
          }
          let encoded = encodeURIComponent(response.data.link)
          let src = process.env.APP_API_URL + `/order/excel_file.csv?q=${encoded}`
          let frame = document.createElement('iframe')
          frame.setAttribute('src', src)
          main.appendChild(frame)
        })
        .catch((messages, error) => {
          this.$toastr.warning('エラーが発生しました。')
        })
        .finally(() => {
          this.exclusiveLock = false
        })
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/Fabric/index.vue